function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoGoogle(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.185 12c0-.65.111-1.273.307-1.857L3.05 7.568A9.83 9.83 0 002 12a9.83 9.83 0 001.047 4.43l3.442-2.58A5.807 5.807 0 016.185 12"
  }), React.createElement("path", {
    fill: "#EA4335",
    d: "M12.233 6.088c1.44 0 2.743.5 3.766 1.318l2.977-2.91c-1.814-1.546-4.139-2.501-6.743-2.501-4.044 0-7.52 2.264-9.184 5.573l3.445 2.575c.793-2.359 3.054-4.055 5.739-4.055"
  }), React.createElement("path", {
    fill: "#34A853",
    d: "M12.233 17.912c-2.685 0-4.947-1.696-5.74-4.055l-3.444 2.576c1.664 3.308 5.14 5.572 9.184 5.572 2.495 0 4.877-.867 6.666-2.493l-3.269-2.475c-.922.569-2.083.875-3.398.875"
  }), React.createElement("path", {
    fill: "#4285F4",
    d: "M22 12c0-.59-.094-1.228-.233-1.819h-9.535v3.866h5.488a4.503 4.503 0 01-2.09 2.99l3.27 2.475C20.777 17.805 22 15.262 22 12"
  })));
}

SvgLogoGoogle.clsName = 'icon-uc-social__logo-google';
SvgLogoGoogle.remarkName = 'unknown';
export default SvgLogoGoogle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoGoogle.js
// module id = 2241
// module chunks = 17 18